import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, Portal, Stack, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { ButtonVariant } from '../../core/enums';
import { Button } from '../button/button';
import { styles } from './org-servicelines.styles';
import './org-servicelines.scss';
export const OrganizationServiceline = ({ onSelection, actionGroups, activeOrg, handleOrganizationChoice, handleServiceLineChoice, context: cmxContext, activeUser, serviceLine, context, openAccountSettings, setSwitcherOpened, ...props })=>{
    const classes = styles();
    const { activeContext, contexts } = cmxContext;
    const [serviceLines, setServiceLines] = useState(activeContext?.serviceLines || []);
    const [selectedOrgItem, setSelectedOrgItem] = useState(activeContext?.organizationId ?? -1);
    const [selectedServicelineItem, setSelectedServicelineItem] = useState(serviceLine?.id ?? -1);
    const UNSELECTED_ORG = -1;
    const UNSELECTED_SERVICE_LINE = -1;
    const orgSelectionWrapper = (orgId = UNSELECTED_ORG)=>{
        setSelectedOrgItem(orgId);
        setSelectedServicelineItem(-1);
        contexts.forEach((ctx)=>{
            if (ctx.organizationId === orgId) {
                setServiceLines(ctx.serviceLines);
            }
        });
    };
    const servicelineSelectionWrapper = (serviceLineId = UNSELECTED_SERVICE_LINE)=>{
        setSelectedServicelineItem(serviceLineId);
    };
    const handleCancel = ()=>{
        setSelectedOrgItem(activeContext?.organizationId ?? UNSELECTED_ORG);
        setServiceLines(activeContext?.serviceLines || []);
        setSelectedServicelineItem(serviceLine?.id ?? UNSELECTED_SERVICE_LINE);
    };
    const handleApply = async ()=>{
        let choice;
        if (selectedOrgItem !== UNSELECTED_ORG) {
            if (selectedServicelineItem !== UNSELECTED_SERVICE_LINE) {
                choice = {
                    organizationId: selectedOrgItem,
                    servicelineId: selectedServicelineItem,
                    reload: true
                };
            } else {
                choice = {
                    organizationId: selectedOrgItem,
                    reload: true
                };
            }
            handleOrganizationChoice(choice);
            setSwitcherOpened(false);
        }
    };
    const isOrgSelected = (currentOrgId, selectedOrganizationItem, index)=>{
        const currentOrgSelectionCheck = currentOrgId === selectedOrganizationItem ? 'selectedItem' : '';
        const firstOrgCheck = index === 0 ? 'selectedItem' : '';
        return selectedOrganizationItem !== UNSELECTED_ORG ? currentOrgSelectionCheck : firstOrgCheck;
    };
    const isServicelineSelected = (currentServicelineId, selectedServicelineItemId, index)=>{
        const currentServicelineCheck = currentServicelineId === selectedServicelineItemId ? 'selectedItem' : '';
        const firstServicelineCheck = index === 0 ? 'selectedItem' : '';
        return selectedServicelineItemId !== UNSELECTED_SERVICE_LINE ? currentServicelineCheck : firstServicelineCheck;
    };
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsxs(PopoverContent, {
            sx: {
                ...classes['.mainGrid'],
                _focus: {
                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                    outline: 'none'
                },
                _focusVisible: {
                    boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                    outline: 'none'
                }
            },
            className: "popOverStyle",
            children: [
                /*#__PURE__*/ _jsx(PopoverHeader, {
                    sx: classes['.headerGrid'],
                    children: /*#__PURE__*/ _jsx(Flex, {
                        alignItems: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            children: contexts.length === 1 ? activeContext?.displayName : 'My Organizations'
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(PopoverBody, {
                    sx: classes['.bodyGrid'],
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        children: [
                            contexts.length > 1 ? /*#__PURE__*/ _jsx(Box, {
                                sx: classes['.popoverOrgBox'],
                                children: contexts.map((ctx, index)=>{
                                    return /*#__PURE__*/ _jsx(Flex, {
                                        sx: classes['.switchItem'],
                                        onClick: ()=>{
                                            orgSelectionWrapper(ctx.organizationId);
                                        },
                                        className: `hoverCursor ${isOrgSelected(ctx.organizationId, selectedOrgItem, index)}`,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ctx.displayName && ctx.displayName !== '' ? ctx.displayName : ctx.shortDisplayName && ctx.shortDisplayName !== '' ? ctx.shortDisplayName : ctx.organizationCode
                                        })
                                    }, ctx.organizationId);
                                })
                            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                            serviceLines.length !== 0 ? /*#__PURE__*/ _jsx(Box, {
                                sx: classes['.popoverServicelineBox'],
                                children: serviceLines.map((sl, index)=>{
                                    return /*#__PURE__*/ _jsx(Flex, {
                                        sx: classes['.switchItem'],
                                        onClick: ()=>{
                                            servicelineSelectionWrapper(sl.id);
                                        },
                                        className: `hoverCursor ${isServicelineSelected(sl.id, selectedServicelineItem, index)}`,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: sl?.displayName || sl?.name
                                        })
                                    }, sl.id);
                                })
                            }) : /*#__PURE__*/ _jsx(Box, {
                                sx: classes['.popoverServicelineBox'],
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: "No service line available"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(PopoverFooter, {
                    sx: classes['.popoverFooter'],
                    children: /*#__PURE__*/ _jsxs(Box, {
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(PopoverCloseButton, {
                                sx: classes['.footerButton'],
                                position: "inherit",
                                right: "auto",
                                p: "auto",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    label: "Cancel",
                                    variant: ButtonVariant.SECONDARY,
                                    sx: classes['.footerButton'],
                                    onClick: handleCancel
                                })
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                label: "Apply",
                                sx: classes['.footerButton'],
                                onClick: handleApply
                            })
                        ]
                    })
                })
            ]
        })
    });
};
OrganizationServiceline.displayName = 'OrganizationServiceline';
